// Special assets needed by the login page

import '../setup/jquery_setup'
